import React, { useState } from 'react'
import i18n from 'live/services/i18n'
import * as S from './styled'

interface Props {
    label: string
    onClick: () => void
    active: boolean
    height?: number
    width?: number
}

const ButtonSelector: React.FC<Props> = ({ label, onClick, active, height, width }) => {
    return (
        <>
            <S.SelectorButtonDiv style={{ width: width ? width + 'px' : undefined }}>
                <S.GraySelectorButton
                    style={{ opacity: active ? 1 : 0.7, padding: height ? height + 'px ' + height + 'px' : undefined }}
                    className="btn btn-block"
                    onClick={onClick}
                >
                    {i18n(label)}
                </S.GraySelectorButton>
            </S.SelectorButtonDiv>
        </>
    )
}

export default ButtonSelector
